import React, { useEffect, useState } from "react";
import { useParams, useLocation ,useNavigate} from "react-router-dom";
import axios from "axios";
import { Spin , Popconfirm } from "antd";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  VideoCameraOutlined,
  LinkOutlined,
  FileTextOutlined,
  PlusOutlined,
  UserOutlined,
  ReadOutlined 
} from "@ant-design/icons";
import VideoPlayer from "../VideoPlayer";






function ClassDetails() {
  const { id, CourseName } = useParams();
  const location = useLocation();

  const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
const [selectedFile, setSelectedFile] = useState(null);
const [uploading, setUploading] = useState(false);
const [uploadProgress, setUploadProgress] = useState(0);

const [isNotesModalOpen, setIsNotesModalOpen] = useState(false);
const [selectedNotesFile, setSelectedNotesFile] = useState(null);
const [notesUploading, setNotesUploading] = useState(false);
const [notesUploadProgress, setNotesUploadProgress] = useState(0);

const [notes, setNotes] = useState([]);
const [notesLoading, setNotesLoading] = useState(false);

const [isExtraClassModalOpen, setIsExtraClassModalOpen] = useState(false);
const [newClassName, setNewClassName] = useState("");
const [creatingClass, setCreatingClass] = useState(false);

const [isPlayerOpen, setIsPlayerOpen] = useState(false);
const [videoUrl, setVideoUrl] = useState(null);


  const navigate = useNavigate();

  // Auth info
  const token = localStorage.getItem("token");
  const fullName = localStorage.getItem("fullName");
  const role = (localStorage.getItem("role") || "").toUpperCase();

  useEffect(() => {
    if (!token || !fullName || !role) {
      navigate("/user/sign_in");
    }
  }, [token, fullName, role, navigate]);


  const { BatchName, BatchType } = location.state || {};

  const [loading, setLoading] = useState(true);
  const [classData, setClassData] = useState(null);

  useEffect(() => {
    fetchClassDetails();
  }, []);

  const fetchClassDetails = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/course-content/get-single-class-details`,
        {
          id,
          CourseName,
    
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.data.success) {
        setClassData(response.data.data);
      } else {
        toast.error(response.data.message);
      }
    } catch (err) {
      toast.error(
        err.response?.data?.message || "Failed to load class details"
      );
    } finally {
      setLoading(false);
    }
  };


  const handleVideoUpload = async () => {
  if (!selectedFile) {
    toast.error("Please select a video file");
    return;
  }

  try {
    setUploading(true);
    setUploadProgress(0);

    const formData = new FormData();
    formData.append("id", id);
    formData.append("video", selectedFile);

    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/course-content/upload-video`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setUploadProgress(percent);
          }
        },
      }
    );

    /* ✅ Check Backend Success */
    if (res.data.success) {
      toast.success(res.data.message || "Video uploaded successfully");

      setIsUploadModalOpen(false);
      setSelectedFile(null);
      setUploadProgress(0);

      fetchClassDetails(); // refresh class data
    } else {
      toast.error(res.data.message || "Upload failed");
    }

  } catch (err) {
    toast.error(
      err.response?.data?.message || "Upload failed"
    );
  } finally {
    setUploading(false);
  }
};

const handleWatchRecording = async () => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/course-content/get-recording-url`,
      { key: classData.RecordingLink },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (res.data.success) {
      // console.log("Signed URL:", res.data.url);

      setVideoUrl(res.data.url);
      setIsPlayerOpen(true);  // 🔥 no timeout
    }
  } catch (err) {
    toast.error("Failed to load recording");
  }
};

const handleNotesUpload = async () => {
  if (!selectedNotesFile) {
    toast.error("Please select a notes file");
    return;
  }

  try {
    setNotesUploading(true);
    setNotesUploadProgress(0);

    const formData = new FormData();
    formData.append("id", id);
    formData.append("notes", selectedNotesFile);

    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/course-content/upload-notes`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          if (progressEvent.total) {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            setNotesUploadProgress(percent);
          }
        },
      }
    );

    if (res.data.success) {
      toast.success(res.data.message || "Notes uploaded successfully");

      setIsNotesModalOpen(false);
      setSelectedNotesFile(null);
      setNotesUploadProgress(0);

      fetchClassDetails();
    } else {
      toast.error(res.data.message);
    }

  } catch (err) {
    toast.error(err.response?.data?.message || "Notes upload failed");
  } finally {
    setNotesUploading(false);
  }
};

const fetchClassNotes = async () => {
  try {

    setNotesLoading(true);

    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/course-content/get-notes`,
      {
        CourseName: classData.CourseName,
        BatchName: classData.BatchName,
        BatchType: classData.BatchType,
        ModuleNumber: classData.ModuleNumber,
        ClassName: classData.ClassName
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (res.data.success) {
      setNotes(res.data.notes);

     
    }

  } catch (err) {
    console.error("Notes fetch error:", err);
  } finally {
    setNotesLoading(false);
  }
};

useEffect(() => {
  if (classData) {
    fetchClassNotes();
  }
}, [classData]);


const createExtraClass = async () => {

  if (!newClassName.trim()) {
    toast.error("Class name is required");
    return;
  }

  try {

    setCreatingClass(true);

    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/course-content/create-course-content-after-id`,
      {
        CourseName: classData.CourseName,
        BatchName: classData.BatchName,
        BatchType: classData.BatchType,
        ModuleNumber: classData.ModuleNumber,
        ModuleName: classData.ModuleName,
        ClassName: newClassName,
        Id: id
      },
      {
        headers: { Authorization: `Bearer ${token}` }
      }
    );

    if (res.data.success) {
      toast.success(res.data.message);

      setIsExtraClassModalOpen(false);
      setNewClassName("");

    }

  } catch (err) {
    toast.error(err.response?.data?.message || "Failed to create class");
  } finally {
    setCreatingClass(false);
  }
};

const deleteNote = async (noteId) => {

 

  try {

    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/course-content/delete-notes`,
      { id: noteId },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (res.data.success) {
      
      toast.success("Note deleted successfully");
       // reload notes
       
       setNotes([]);
       fetchClassNotes();
      fetchClassDetails();
    }

  } catch (err) {
    toast.error(err.response?.data?.message || "Delete failed");
  }

};

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spin size="large" />
      </div>
    );
  }

  if (!classData) return <div>No Class Found</div>;

  

 return (
  <div className="min-h-screen px-6 bg-slate-200 py-14">

     <ToastContainer
                        position="bottom-left"
                        autoClose={5000}
                        hideProgressBar={true}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="dark"
                        className="!mb-6 !ml-4"
                        toastClassName="!inline-flex !items-center !whitespace-nowrap !bg-black !text-white !px-4 !py-2 !rounded-lg !w-auto !min-w-0 !shadow-lg"
                      />

    <div className="max-w-6xl mx-auto">

     


      {/* ================= MAIN CLASS CARD ================= */}
      <div className="p-12 bg-white shadow-xl rounded-xl">

        <div className="flex flex-col gap-12 lg:flex-row">

   {/* ================= VIDEO THUMB (Clean LMS Card Style) ================= */}
<div className="relative w-full lg:w-[480px] h-[260px] rounded-2xl overflow-hidden shadow-lg group">

  {/* Blue Gradient Background */}
  <div className="absolute inset-0 bg-gradient-to-br from-blue-400 via-blue-500 to-blue-600" />

  {/* Subtle Overlay */}
  <div className="absolute inset-0 transition duration-300 bg-black/10 group-hover:bg-black/20" />

  {/* ================= DATE (Top Left) ================= */}
  {classData.ClassDate && (
    <span className="absolute z-20 text-sm font-semibold top-6 left-6 text-white/90">
      {new Date(classData.ClassDate).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })}
    </span>
  )}

  {/* ================= TITLE ================= */}
  <div className="absolute z-20 top-16 left-6 right-32">
    <h2 className="text-xl font-semibold leading-snug text-white">
      {classData.ClassName}
    </h2>
  </div>

 {/* ================= PROFESSIONAL ICON BACKGROUND ================= */}
<div className="absolute z-10 text-white right-8 bottom-6 opacity-20">
  <ReadOutlined  style={{ fontSize: "120px" }} />
</div>

  {/* ================= PLAY BUTTON ================= */}
  {classData.ClassStatus === "COMPLETED" && classData.RecordingLink && (
    <button
      onClick={handleWatchRecording}
      className="absolute inset-0 z-30 flex items-center justify-center"
    >
      <div className="flex items-center justify-center w-16 h-16 transition rounded-full shadow-xl bg-white/90 group-hover:scale-110">
        <svg
          className="w-8 h-8 ml-1 text-blue-600"
          fill="currentColor"
          viewBox="0 0 24 24"
        >
          <path d="M8 5v14l11-7z" />
        </svg>
      </div>
    </button>
  )}

  {/* ================= GREEN PROGRESS BAR ================= */}
  <div className="absolute bottom-0 left-0 z-20 w-full h-1 bg-green-400" />

</div>


          {/* ================= CLASS INFO ================= */}
<div className="relative flex flex-col justify-center flex-1">

{/* ================= SESSION RECORDING RIBBON ================= */}
{classData.ClassStatus === "COMPLETED" && (
  <div className="mb-1 w-fit">
    <div className="relative px-6 py-3 text-sm font-semibold bg-yellow-400 shadow-md text-slate-900 rounded-r-md">
      Session Recording
      <span className="absolute top-0 right-[-20px] w-0 h-0 
        border-t-[24px] border-b-[20px] border-l-[22px] 
        border-t-transparent border-b-transparent border-l-yellow-400">
      </span>
    </div>
  </div>
)}

 {classData.ClassStatus === "PENDING" && (
  <div className="mb-4 w-fit">
    <div className="relative px-6 py-3 text-sm font-semibold text-white bg-red-600 shadow-md rounded-r-md">
      Session Pending
      <span className="absolute top-0 right-[-20px] w-0 h-0 
        border-t-[24px] border-b-[20px] border-l-[22px] 
        border-t-transparent border-b-transparent border-l-red-600">
      </span>
    </div>
  </div>
)}

  {/* Title */}
  <h1 className="mt-2 text-2xl font-bold text-slate-900">
    {classData.ClassName}
  </h1>

  <p className="mt-1 text-base font-semibold text-slate-600">
    Module {classData.ModuleNumber}: {classData.ModuleName}
  </p>

 {/* Date Badge - Only if Completed */}
{classData.ClassStatus === "COMPLETED" && classData.ClassDate && (
  <div className="flex items-center gap-2 px-4 py-2 mb-3 text-base font-bold rounded-md bg-slate-300 text-slate-700 w-fit">
    
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6 text-red-500"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
      />
    </svg>

    {new Date(classData.ClassDate).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    })}
    
  </div>
)}


  {/* ================= ACTION BUTTONS ================= */}
 

   {classData.ClassStatus === "PENDING" ? (

  /* JOIN LIVE BUTTON */
  <button
    onClick={() => {
      if (classData.CourseUrl) {
        window.open(classData.CourseUrl, "_blank");
      }
    }}
    disabled={!classData.CourseUrl}
    className={`px-6 py-3 text-sm font-semibold rounded-xl transition shadow-sm ${
      classData.CourseUrl
        ? "bg-green-600 text-white hover:bg-green-500"
        : "bg-slate-200 text-slate-400 cursor-not-allowed"
    }`}
  >
    🚀 Join Live
  </button>

) : (

  /* WATCH RECORDING BUTTON */
  <button
    onClick={handleWatchRecording}
    disabled={!classData.RecordingLink}
    className={`px-6 py-3 text-sm font-semibold rounded-xl transition shadow-sm ${
      classData.RecordingLink
        ? "bg-red-600 text-white hover:bg-red-500"
        : "bg-slate-200 text-slate-400 cursor-not-allowed"
    }`}
  >
    ▶ Watch Recording
  </button>

)}


    {/* ================= ACTION GRID ================= */}
      <div className="grid grid-cols-1 gap-4 mt-8 md:grid-cols-2">

        {/* Upload Video */}
        <button
          onClick={() => setIsUploadModalOpen(true)}
          className="flex items-center justify-center gap-3 px-6 py-4 text-sm font-semibold text-white transition-all duration-200 shadow-md rounded-2xl bg-gradient-to-r from-indigo-600 to-violet-600 hover:scale-[1.02] hover:shadow-xl"
        >
          <VideoCameraOutlined />
          Upload Video
        </button>

        {/* Create Session Link */}
        <button className="flex items-center justify-center gap-3 px-6 py-4 text-sm font-semibold text-white transition-all duration-200 shadow-md rounded-2xl bg-gradient-to-r from-sky-600 to-blue-600 hover:scale-[1.02] hover:shadow-xl">
          <LinkOutlined />
          Create Session Link
        </button>

        {/* Upload Notes */}
        <button
          onClick={() => setIsNotesModalOpen(true)}
          className="flex items-center justify-center gap-3 px-6 py-4 text-sm font-semibold text-white transition-all duration-200 shadow-md rounded-2xl bg-gradient-to-r from-emerald-600 to-teal-500 hover:scale-[1.02] hover:shadow-xl"
        >
          <FileTextOutlined />
          Upload Notes
        </button>

        {/* Add Extra Class */}
        <button
          onClick={() => setIsExtraClassModalOpen(true)}
          className="flex items-center justify-center gap-3 px-6 py-4 text-sm font-semibold text-white transition-all duration-200 shadow-md rounded-2xl bg-gradient-to-r from-fuchsia-600 to-purple-600 hover:scale-[1.02] hover:shadow-xl"
        >
          <PlusOutlined />
          Add Extra Class
        </button>

      </div>

</div>

        </div>

      </div>


      {/* ================= CLASS META INFO ================= */}
<div className="grid grid-cols-1 gap-5 mt-10 md:grid-cols-2 xl:grid-cols-3">

  <div className="group relative overflow-hidden rounded-2xl border border-slate-200 bg-white p-5 shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg">
    <div className="absolute top-0 left-0 h-full w-1.5 bg-blue-600" />
    <div className="pl-3">
      <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">
        Course Name
      </p>
      <h3 className="mt-2 text-lg font-bold break-words text-slate-900">
        {classData.CourseName}
      </h3>
    </div>
  </div>

  <div className="group relative overflow-hidden rounded-2xl border border-slate-200 bg-white p-5 shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg">
    <div className="absolute top-0 left-0 h-full w-1.5 bg-emerald-600" />
    <div className="pl-3">
      <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500">
        Batch
      </p>
      <h3 className="mt-2 text-lg font-bold break-words text-slate-900">
        {classData.BatchName}{" "}
        <span className="font-semibold text-slate-500">
          ({classData.BatchType})
        </span>
      </h3>
    </div>
  </div>

</div>


 {/* ================= NOTES SECTION ================= */}
<div className="p-10 bg-white shadow-lg mt-14 rounded-3xl">

  <h2 className="text-xl font-semibold text-slate-800">
    Lecture Notes
  </h2>

  {notesLoading && (
    <p className="mt-6 text-sm text-slate-500">
      Loading notes...
    </p>
  )}

  {!notesLoading && notes.length === 0 && (
    <p className="mt-6 text-sm text-slate-500">
      Notes are not uploaded yet for this class.
    </p>
  )}

  {notes.length > 0 && (
  <div className="flex flex-col mt-6 divide-y divide-slate-200">

    {notes.map((note, index) => (
      <div
        key={index}
        className="flex items-center justify-between py-4 transition hover:bg-slate-50 group"
      >

        <a
          href={note.url}
          target="_blank"
          rel="noreferrer"
          className="flex items-center gap-3"
        >
          <FileTextOutlined className="text-lg text-blue-600" />

          <span className="text-sm font-semibold text-blue-600 transition group-hover:text-blue-800">
            {classData.ClassName} Notes {index + 1}
          </span>
        </a>

        {/* DELETE BUTTON */}
       <Popconfirm
  title="Delete Note"
  description="Are you sure you want to delete this Class notes file?"
  okText="Delete"
  cancelText="Cancel"
  onConfirm={() => deleteNote(note.id)}
>
  <button className="px-3 py-1 text-xs font-semibold text-red-600 transition bg-red-100 rounded-md hover:bg-red-200">
    Delete 
  </button>
</Popconfirm>

      </div>
    ))}

  </div>
)}

</div>

    </div>

    
  {/* ================= VIDEO UPLOAD MODAL ================= */}
{isUploadModalOpen && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm">

    <div className="w-full max-w-2xl p-6 bg-white shadow-xl rounded-2xl">

      {/* ===== HEADER ===== */}
      <div className="flex items-center justify-between pb-4 border-b border-slate-200">

        <div className="flex items-center gap-3">

          <div className="flex items-center justify-center w-8 h-8 bg-indigo-100 rounded-md">
            <VideoCameraOutlined className="text-indigo-600" />
          </div>

          <div>
            <h2 className="text-lg font-semibold text-slate-900">
              Upload Class Recording
            </h2>
            <p className="text-xs text-slate-500">
              Upload session recording for this class
            </p>
          </div>

        </div>

        <button
          onClick={() => {
            setIsUploadModalOpen(false);
            setSelectedFile(null);
          }}
          className="text-lg text-slate-400 hover:text-slate-600"
        >
          ✕
        </button>

      </div>

      {/* ===== CLASS INFO ===== */}
      <div className="grid grid-cols-2 gap-4 p-4 mt-5 text-sm border rounded-lg bg-slate-50 border-slate-200">

        <InfoItem label="Course" value={classData.CourseName} />
        <InfoItem label="Batch" value={`${classData.BatchName} (${classData.BatchType})`} />
        <InfoItem label="Class" value={classData.ClassName} />
        <InfoItem label="Module" value={`${classData.ModuleNumber} - ${classData.ModuleName}`} />

      </div>

      {/* ===== VIDEO UPLOAD AREA ===== */}
      <div className="mt-5">

        <label className="block mb-2 text-sm font-medium text-slate-700">
          Upload Recording
        </label>

        <div className="relative flex flex-col items-center justify-center p-5 transition border-2 border-dashed rounded-lg border-slate-300 hover:border-indigo-500 hover:bg-indigo-50">

          <VideoCameraOutlined className="mb-2 text-xl text-indigo-500" />

          <p className="text-xs text-slate-600">
            Click to upload video file
          </p>

          <p className="mt-1 text-xs text-slate-400">
            MP4, MOV, AVI, MKV
          </p>

          <input
            type="file"
            accept="video/*"
            onChange={(e) => setSelectedFile(e.target.files[0])}
            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
          />

        </div>

        {/* Selected File */}
        {selectedFile && (
          <div className="flex items-center gap-2 p-2 mt-3 text-xs border rounded-md bg-slate-50">

            <VideoCameraOutlined className="text-indigo-500" />

            <span className="font-medium text-slate-700">
              {selectedFile.name}
            </span>

          </div>
        )}

      </div>

      {/* ===== PROGRESS BAR ===== */}
      {uploading && (
        <div className="mt-4">

          <div className="h-2 overflow-hidden rounded-full bg-slate-200">

            <div
              className="h-full transition-all duration-300 bg-indigo-500"
              style={{ width: `${uploadProgress}%` }}
            />

          </div>

          <p className="mt-1 text-xs text-indigo-600">
            Uploading... {uploadProgress}%
          </p>

        </div>
      )}

      {/* ===== ACTION BUTTONS ===== */}
      <div className="flex justify-end gap-3 mt-5">

        <button
          onClick={() => {
            setIsUploadModalOpen(false);
            setSelectedFile(null);
          }}
          disabled={uploading}
          className="px-4 py-2 text-xs font-semibold transition rounded-md text-slate-600 bg-slate-100 hover:bg-slate-200"
        >
          Cancel
        </button>

        <button
          onClick={handleVideoUpload}
          disabled={uploading}
          className={`px-4 py-2 text-xs font-semibold text-white rounded-md transition ${
            uploading
              ? "bg-indigo-300 cursor-not-allowed"
              : "bg-indigo-600 hover:bg-indigo-500"
          }`}
        >
          {uploading ? "Uploading..." : "Upload Video"}
        </button>

      </div>

    </div>
  </div>
)}

{isPlayerOpen && videoUrl && (
  <div className="fixed inset-0 z-[9999] bg-black flex flex-col">

    {/* ===== TOP BAR ===== */}
    <div className="flex items-center justify-between px-6 py-4 bg-black/80 backdrop-blur-md">
      
      {/* Back Button */}
      <button
        onClick={() => {
          setIsPlayerOpen(false);
          setVideoUrl(null);
        }}
        className="flex items-center gap-2 text-lg font-semibold text-white transition hover:text-red-400"
      >
        ← Back
      </button>

      {/* Optional Title */}
      <h2 className="text-lg font-medium text-white">
        {classData.ClassName} Session Recording
      </h2>

      {/* Empty div for spacing symmetry */}
      <div className="w-[80px]" />
    </div>

    {/* ===== VIDEO AREA ===== */}
<div className="flex items-center justify-center flex-1 bg-black">
  <div className="w-full h-full">

    <div className="w-full h-full">
      <VideoPlayer key={videoUrl} url={videoUrl} />
    </div>

  </div>
</div>

  </div>
)}


{/* ================= NOTES UPLOAD MODAL ================= */}
{isNotesModalOpen && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm">

    <div className="w-full max-w-2xl p-6 bg-white shadow-xl rounded-2xl">

      {/* ===== HEADER ===== */}
      <div className="flex items-center justify-between pb-4 border-b border-slate-200">

        <div className="flex items-center gap-3">

          <div className="flex items-center justify-center w-8 h-8 bg-indigo-100 rounded-md">
            <FileTextOutlined className="text-indigo-600" />
          </div>

          <div>
            <h2 className="text-lg font-semibold text-slate-900">
              Upload Class Notes
            </h2>
            <p className="text-xs text-slate-500">
              Upload lecture material
            </p>
          </div>

        </div>

        <button
          onClick={() => setIsNotesModalOpen(false)}
          className="text-lg text-slate-400 hover:text-slate-600"
        >
          ✕
        </button>

      </div>

      {/* ===== CLASS INFO ===== */}
      <div className="grid grid-cols-2 gap-4 p-4 mt-5 text-sm border rounded-lg bg-slate-50 border-slate-200">

        <InfoItem label="Course" value={classData.CourseName} />
        <InfoItem label="Batch" value={`${classData.BatchName} (${classData.BatchType})`} />
        <InfoItem label="Class" value={classData.ClassName} />
        <InfoItem label="Module" value={`${classData.ModuleNumber} - ${classData.ModuleName}`} />

      </div>

      {/* ===== FILE UPLOAD AREA ===== */}
      <div className="mt-5">

        <label className="block mb-2 text-sm font-medium text-slate-700">
          Upload Notes
        </label>

        <div className="relative flex flex-col items-center justify-center p-5 transition border-2 border-dashed rounded-lg border-slate-300 hover:border-indigo-500 hover:bg-indigo-50">

          <FileTextOutlined className="mb-2 text-xl text-indigo-500" />

          <p className="text-xs text-slate-600">
            Click to upload PDF, DOC, PPT
          </p>

          <input
            type="file"
            accept=".pdf,.doc,.docx,.ppt,.pptx"
            onChange={(e) => setSelectedNotesFile(e.target.files[0])}
            className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
          />

        </div>

        {/* Selected File */}
        {selectedNotesFile && (
          <div className="flex items-center gap-2 p-2 mt-3 text-xs border rounded-md bg-slate-50">

            <FileTextOutlined className="text-indigo-500" />

            <span className="font-medium text-slate-700">
              {selectedNotesFile.name}
            </span>

          </div>
        )}

      </div>

      {/* ===== PROGRESS BAR ===== */}
      {notesUploading && (
        <div className="mt-4">

          <div className="h-2 overflow-hidden rounded-full bg-slate-200">

            <div
              className="h-full transition-all duration-300 bg-indigo-500"
              style={{ width: `${notesUploadProgress}%` }}
            />

          </div>

          <p className="mt-1 text-xs text-indigo-600">
            Uploading... {notesUploadProgress}%
          </p>

        </div>
      )}

      {/* ===== ACTION BUTTONS ===== */}
      <div className="flex justify-end gap-3 mt-5">

        <button
          onClick={() => setIsNotesModalOpen(false)}
          disabled={notesUploading}
          className="px-4 py-2 text-xs font-semibold transition rounded-md text-slate-600 bg-slate-100 hover:bg-slate-200"
        >
          Cancel
        </button>

        <button
          onClick={handleNotesUpload}
          disabled={notesUploading}
          className={`px-4 py-2 text-xs font-semibold text-white rounded-md transition ${
            notesUploading
              ? "bg-indigo-300 cursor-not-allowed"
              : "bg-indigo-600 hover:bg-indigo-500"
          }`}
        >
          {notesUploading ? "Uploading..." : "Upload Notes"}
        </button>

      </div>

    </div>
  </div>
)}


{/* ================= ADD EXTRA CLASS MODAL ================= */}
{isExtraClassModalOpen && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm">

    <div className="w-full max-w-xl p-6 bg-white shadow-xl rounded-2xl">

      {/* HEADER */}
      <div className="flex items-center justify-between pb-4 border-b border-slate-200">

        <div className="flex items-center gap-3">

          <div className="flex items-center justify-center w-8 h-8 bg-purple-100 rounded-md">
            <PlusOutlined className="text-purple-600" />
          </div>

          <div>
            <h2 className="text-lg font-semibold text-slate-900">
              Create Extra Class
            </h2>
            <p className="text-xs text-slate-500">
              Add a new class to this module
            </p>
          </div>

        </div>

        <button
          onClick={() => setIsExtraClassModalOpen(false)}
          className="text-lg text-slate-400 hover:text-slate-600"
        >
          ✕
        </button>

      </div>

      {/* CLASS INFO */}
      <div className="grid grid-cols-2 gap-4 p-4 mt-5 text-sm border rounded-lg bg-slate-50 border-slate-200">

        <InfoItem label="Course" value={classData.CourseName} />
        <InfoItem label="Batch" value={`${classData.BatchName} (${classData.BatchType})`} />
        <InfoItem label="Module" value={`${classData.ModuleNumber}`} />
        <InfoItem label="Module Name" value={classData.ModuleName} />

      </div>

      {/* CLASS NAME INPUT */}
      <div className="mt-5">

        <label className="block mb-2 text-sm font-medium text-slate-700">
          Class Name
        </label>

        <input
          type="text"
          value={newClassName}
          onChange={(e) => setNewClassName(e.target.value)}
          placeholder="Enter class name"
          className="w-full px-3 py-2 text-sm border rounded-md border-slate-300 focus:outline-none focus:ring-2 focus:ring-purple-500"
        />

      </div>

      {/* ACTION BUTTONS */}
      <div className="flex justify-end gap-3 mt-6">

        <button
          onClick={() => setIsExtraClassModalOpen(false)}
          className="px-4 py-2 text-xs font-semibold transition rounded-md text-slate-600 bg-slate-100 hover:bg-slate-200"
        >
          Cancel
        </button>

        <button
          onClick={createExtraClass}
          disabled={creatingClass}
          className={`px-4 py-2 text-xs font-semibold text-white rounded-md transition ${
            creatingClass
              ? "bg-purple-300 cursor-not-allowed"
              : "bg-purple-600 hover:bg-purple-500"
          }`}
        >
          {creatingClass ? "Creating..." : "Create Class"}
        </button>

      </div>

    </div>
  </div>
)}
  </div>
);
}

function MetaCard({ label, value }) {
  return (
    <div className="p-6 bg-white border shadow-sm rounded-2xl border-slate-200">
      <p className="text-xs tracking-wide uppercase text-slate-500">
        {label}
      </p>
      <p className="mt-2 text-lg font-semibold text-slate-800">
        {value}
      </p>
    </div>
  );
}

function InfoItem({ label, value }) {
  return (
    <div>
      <p className="text-xs font-medium tracking-wide uppercase text-slate-400">
        {label}
      </p>
      <p className="mt-1 text-sm font-semibold text-slate-800">
        {value}
      </p>
    </div>
  );
}
export default ClassDetails;